import * as am4core from "@amcharts/amcharts4/core";
import { SPACE_CADET, HARVARD_CRIMSON } from "constants/colors";

export const COLORS1 = [
  am4core.color(SPACE_CADET),
  am4core.color(HARVARD_CRIMSON),
];
